import { render, staticRenderFns } from "./activityPrizeList.vue?vue&type=template&id=51937dee&scoped=true"
import script from "./activityPrizeList.vue?vue&type=script&lang=js"
export * from "./activityPrizeList.vue?vue&type=script&lang=js"
import style0 from "./activityPrizeList.vue?vue&type=style&index=0&id=51937dee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51937dee",
  null
  
)

export default component.exports